"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));
var _excluded = ["isOpen"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var AnimatedHamburgerMenu = props => {
  var {
      isOpen
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  var classes = (0, _styles.default)(props);

  /**
   * Renders a bar of the three bar hamburger menu along with its animation class
   */
  var renderBar = animatedClass => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.menuBarBase, isOpen && animatedClass)
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ButtonBase.default, _extends({
    color: "inherit",
    "aria-label": "menu",
    disableRipple: true
  }, other), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, renderBar(classes.animatedTopBar), renderBar(classes.animatedMidBar), renderBar(classes.animatedBottomBar)));
};
var _default = exports.default = AnimatedHamburgerMenu;